<template>
  <div>
    <div class="d-flex align-items-center px-3 mb-4">
      <div>
        <span class="h4">مدارک هویتی</span>
      </div>
    </div>
    <div v-if="is_authenticated_pending">
      <div class="px-4">
        <span>
          {{ $t("authenticate.pending") }}
        </span>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-12 col-md-6">
          <ul class="list-group mb-4">
            <li class="border-0 px-0 py-1 list-group-item bg-white">
              <img
                  src="@/pages/dashboard/userwizard/assets/check.svg"
                  width="16"
                  height="16"
                  class="filter_green"
              />
              <span class="pr-3">{{ $t("authenticate.hint.first") }}</span>
            </li>
            <li class="border-0 px-0 py-1 list-group-item bg-white">
              <img
                  src="@/pages/dashboard/userwizard/assets/check.svg"
                  width="16"
                  height="16"
                  class="filter_green"
              />
              <span class="pr-3">{{ $t("authenticate.hint.second") }}</span>
            </li>
            <li class="border-0 px-0 py-1 list-group-item bg-white">
              <img
                  src="@/pages/dashboard/userwizard/assets/check.svg"
                  width="16"
                  height="16"
                  class="filter_green"
              />
              <span class="pr-3">{{ $t("authenticate.hint.third") }}</span>
            </li>
            <li class="border-0 px-0 py-1 list-group-item bg-white">
              <img
                  src="@/pages/dashboard/userwizard/assets/check.svg"
                  width="16"
                  height="16"
                  class="filter_green"
              />
              <span class="pr-3">{{ $t("authenticate.hint.fourth") }}</span>
            </li>
            <li class="border-0 px-0 py-1 list-group-item bg-white">
              <img
                  src="@/pages/dashboard/userwizard/assets/check.svg"
                  width="16"
                  height="16"
                  class="filter_green"
              />
              <span class="pr-3">{{ $t("authenticate.hint.fifth") }}</span>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-6">
          <form class="m-3" id="auth_form">
            <div class="form-group mb-1">
              <label
                  for="authenticate_file"
                  class="btn btn-outline-secondary btn-wide label-file"
              >
                <i class="fas fa-paperclip px-2"></i>
                <span v-if="current_user.user_type == user_types.LEGAL">{{ $t('label.signature_holder_authenticate_file') }}</span>
                <span v-else>{{ $t('label.authenticate_file') }}</span>
              </label>
              <input
                  @change="processAuthenticateFile"
                  type="file"
                  name="authenticate_file"
                  id="authenticate_file"
                  class="custom-file-upload"
                  accept=".jpg,.jpeg,image/png"
              />
            </div>

            <div class="form-group mb-1">
              <label
                  for="national_card_file"
                  class="btn btn-outline-secondary btn-wide label-file"
              >
                <i class="fas fa-paperclip px-2"></i>
                <span v-if="current_user.user_type == user_types.LEGAL">{{ $t('label.signature_holder_national_card_file') }}</span>
                <span v-else>{{ $t('label.national_card_file') }}</span>
              </label>
              <input
                  @change="processNationalCardFile"
                  type="file"
                  name="national_card_file"
                  id="national_card_file"
                  class="custom-file-upload"
                  accept=".jpg,.jpeg,image/png"
              />
            </div>

            <div v-if="current_user.user_type == user_types.LEGAL" class="form-group mb-1">
              <label
                  for="latest_change_file"
                  class="btn btn-outline-secondary btn-wide label-file"
              >
                <i class="fas fa-paperclip px-2"></i>
                {{ $t("label.rrk_latest_change") }}
              </label>
              <input
                  @change="processLatestChangeFile"
                  type="file"
                  name="latest_change_file"
                  id="latest_change_file"
                  class="custom-file-upload"
                  accept=".jpg,.jpeg,image/png"
              />
            </div>
          </form>
        </div>
      </div>
      <div class="d-flex align-items-center px-3 mt-5">
        <div>
          <button
              type="button"
              class="btn btn-success px-4"
              style="border-radius: 10px"
              @click="--wizard.current_step"
          >
            مرحله قبل
          </button>
        </div>
        <div class="mr-auto">
          <button
              type="button"
              @click="submitForm"
              class="btn btn-success px-4"
              style="border-radius: 10px"
              id="submit_btn"
              :disabled="form_submit_loading"
          >
            <span v-if="form_submit_loading">
              <span class="pl-2">در حال انجام</span>
              <span
                  class="spinner-border spinner-border-sm p-2"
                  role="status"
              ></span>
            </span>
            <span v-else>ثبت نهایی</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { userService } from "@/common/api.service";
import { mapGetters } from "vuex";
import { i18n } from "@/plugins/i18n";
import { userStatusStr, userStatus } from "@/constants/userStatus";
import { userTypes } from '@/constants/userTypes';

export default {
  props: {
    wizard: Object,
  },
  data() {
    return {
      user_types: userTypes,
      authenticate_file: null,
      national_card_file: null,
      latest_change_file: null,
      userStatus: userStatus,
      form_submit_loading: false,
    };
  },
  computed: {
    ...mapGetters("user", [
      "is_authenticated_pending",
      "profile_completed",
      "current_user",
    ]),
  },
  methods: {
    submitForm(e) {
      let form = $("#auth_form");

      form.validate({
        rules: {
          authenticate_file: {
            required: true,
          },
          national_card_file: {
            required: true,
          },
          latest_change_file: {
            required: () => {
              return this.current_user.user_type == this.user_types.LEGAL;
            },
          }
        },
      });

      if (!form.valid()) {
        return;
      }

      this.form_submit_loading = true;

      let form_data = new FormData();
      form_data.append("authenticate_file", this.authenticate_file);
      form_data.append("national_card_file", this.national_card_file);

      if (this.current_user.user_type == this.user_types.LEGAL) {
        form_data.append('latest_change_file', this.latest_change_file);

        userService.authenticate_legal_user(form_data)
        .then(response => {
            this.$store.commit('user/setAuthenticatePending')
            this.$store.dispatch('badgeCounter/countData')
        })
        .catch(({response}) => {
            this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {
            this.form_submit_loading = false;
        });
    } else {
        userService.authenticate(form_data)
        .then(response => {
            this.$store.commit('user/setAuthenticatePending')
            this.$store.dispatch('badgeCounter/countData')
        })
        .catch(({response}) => {
            this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {
            this.form_submit_loading = false;
        })
      }
    },
    processAuthenticateFile(event) {
      this.authenticate_file = event.target.files[0];

      if (this.validateSize(event.target)) {
        this.validateFormat(event.target);
      }
    },
    processNationalCardFile(event) {
      this.national_card_file = event.target.files[0];

      if (this.validateSize(event.target)) {
        this.validateFormat(event.target);
      }
    },
    processLatestChangeFile(event) {
      this.latest_change_file = event.target.files[0];

      if (this.validateSize(event.target)) {
        this.validateFormat(event.target);
      }
    },
    validateSize(file) {
      if (file.files[0].size > 2097152) {
        alert(i18n.t("authenticate.hint.fourth"));
        $(file).val("");
        return false;
      }
      return true;
    },
    validateFormat(file) {
      let jq_file = $(file);
      let file_name = jq_file.val();
      let extension = file_name.replace(/^.*\./, "");
      if (extension === file_name) {
        extension = "";
      } else {
        extension = extension.toLowerCase();
      }

      switch (extension) {
        case "jpg":
        case "jpeg":
        case "png":
          break;
        default:
          alert(i18n.t("authenticate.input_format_err"));
          $(file).val("");
          return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>
.label-file {
  border: 1px solid #ccc;
  display: inline-block;
  cursor: pointer;
  min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
  visibility: hidden;
}

.filter_green {
  filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg)
  brightness(91%) contrast(101%);
}
</style>
